// Which modules each portal may write to. Only controls what the UI renders;
// the backend enforces the same rules in projectManagerAccess.js and
// accountManagerAccess.js. Roles not listed here may write to everything.

export const MODULES = {
  CLIENTS: "clients",
  CLIENT_PRICE_LIST: "clientPriceList",
  RECEIVABLES: "receivables",
  CLIENT_INVOICES: "clientInvoices",
  CLIENT_PAYMENTS: "clientPayments",
  VENDORS: "vendors",
  VENDOR_PRICE_LIST: "vendorPriceList",
  PAYABLES: "payables",
  VENDOR_INVOICES: "vendorInvoices",
  VENDOR_PAYMENTS: "vendorPayments",
};

// Modules each portal may only view. Anything absent is writable.
const READ_ONLY_MODULES_BY_ROLE = {
  project_manager: new Set([
    MODULES.VENDORS,
    MODULES.VENDOR_PRICE_LIST,
    MODULES.CLIENT_INVOICES,
    MODULES.CLIENT_PAYMENTS,
    MODULES.VENDOR_INVOICES,
    MODULES.VENDOR_PAYMENTS,
  ]),

  account_manager: new Set([
    MODULES.CLIENTS,
    MODULES.RECEIVABLES,
    MODULES.VENDORS,
    MODULES.PAYABLES,
  ]),
};

export const canWrite = (user, module) =>
  !READ_ONLY_MODULES_BY_ROLE[user?.roleSlug]?.has(module);

export const isReadOnly = (user, module) => !canWrite(user, module);
